import { Collection } from 'collect.js';

Collection.prototype.arrayObjectExcept = require('./methods/arrayObjectExcept');

const collect = collection => new Collection(collection);

export default collect;